import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-space",
  "use": "icon-ib-space-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-space\"><path d=\"M179.48 626.18a18 18 0 0 1-17.64-18.54V368.78A36 36 0 0 0 126.92 332 36 36 0 0 0 92 368.78v257.64a72 72 0 0 0 69.84 73.56h697.68a72 72 0 0 0 69.84-73.38V368.78a34.92 34.92 0 1 0-69.78 0v239.04a18 18 0 0 1-17.58 18.54z\" p-id=\"8846\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol